import { createAxiosClient } from "@ntg/component-library/utilities";

export interface IBomVersionD365 {
    dataAreaId: string;
    manufacturedItemNumber: string;
    bomId: string;
    productionSiteId: string;
    productSizeId: string;
    productColorId: string;
    productConfigurationId: string;
    productStyleId: string;
    productVersionId: string;
}

export const getBomVersionByItemD365 = async (
    itemNumber: string,
    dataAreaId: string,
): Promise<IBomVersionD365 | null> => {
    const axiosAuth = createAxiosClient("D365FO");
    const response = await axiosAuth.get<IBomVersionD365 | null>(
        `/BomVersion/GetBomVersionByItemD365`,
        { params: { itemNumber, dataAreaId } },
    );
    return (response.status === 204 || !response.data) ? null : response.data;
};
